import { render } from "./LocalGithubActivity.vue?vue&type=template&id=64dd3fdf&scoped=true&ts=true"
import script from "./LocalGithubActivity.vue?vue&type=script&lang=ts"
export * from "./LocalGithubActivity.vue?vue&type=script&lang=ts"

import "./LocalGithubActivity.vue?vue&type=style&index=0&id=64dd3fdf&scoped=true&lang=css"

import exportComponent from "/home/bwhite/Projects/bryanchriswhite-com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64dd3fdf"]])

export default __exports__